import { useCallback, useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import { useEcho } from '@laravel/echo-react';
import { useAppDispatch, useAppSelector } from 'redux/store/store.types';

import { NotificationEventPayload, setUnreadNotificationCount, useAppNotification } from 'modules/app-notification';

import { Tooltip } from '@material-ui/core';

import { NotificationIcon } from 'components/Icons';

export default function NotificationButton() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { unreadNotificationCount } = useAppSelector((state) => state.appNotification);
  const { currentUser } = useAppSelector((state) => state.authSession);

  const { getUnreadNotificationHandler } = useAppNotification();

  const { leave } = useEcho<NotificationEventPayload>(
    `App.Notification.${currentUser?.id}`,
    ['NewNotification', 'UpdateNotification'],
    (data) => {
      dispatch(setUnreadNotificationCount(data?.payload?.unread_count || 0));
    },
  );

  const getCountLabel = useCallback(() => {
    if (unreadNotificationCount > 99) {
      return '99+';
    }
    return unreadNotificationCount;
  }, [unreadNotificationCount]);

  const handleClick = () => {
    history.push('/notifications');
  };

  useEffect(() => {
    if (currentUser) {
      getUnreadNotificationHandler();
    }

    return () => {
      leave();
    };
  }, []);

  return (
    <Tooltip title="Notifications" placement="bottom">
      <div
        onClick={handleClick}
        className="relative transition-colors duration-200 ease-in-out bg-appGrey150
         flex items-center justify-center rounded-[10px] cursor-pointer
          hover:bg-appDark200 min-w-[52px] w-[52px] h-[52px] sm:min-w-[60px] sm:h-[60px] sm:w-[60px] lg:min-w-[75px] lg:h-[75px] lg:w-[75px]"
      >
        <NotificationIcon className="text-appDark60 w-[28px] h-[28px] sm:w-[30px] sm:h-[30px] lg:w-[40px] lg:h-[40px]" />
        {unreadNotificationCount > 0 && (
          <span className="bg-appThemeColor text-appThemeTextColor absolute py-0.5 px-1 top-2.5 right-3 text-xs font-bold rounded-[6px]">
            {getCountLabel()}
          </span>
        )}
      </div>
    </Tooltip>
  );
}
